import { Button } from "@mui/material";
import React from "react";
export interface CustomButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  variant?: "contained" | "outlined" | "text";
  size?: "small" | "medium" | "large";
  sx?: React.CSSProperties;
}

export const CustomButtonComponent: React.FC<CustomButtonProps> = ({
  label,
  onClick,
  disabled,
  variant = "text",
  size = "medium",
  sx,
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant={variant || "text"}
      size={size}
      sx={{
        ...sx,
        background:
          sx?.backgroundColor || "linear-gradient(to bottom, #A0005C, #FF0080)",
        borderRadius: "8px",
        padding: sx?.padding || "8px 24px",
        color: sx?.color || "#fff",
        fontWeight: "bold",
        textTransform: "none",
        fontSize: "13px",
        width: sx?.width || "280px",
        boxShadow: "none",
        "&:hover": {
          background: "linear-gradient(to bottom, #900050, #e60073)",
          boxShadow: "none",
          color: sx?.color || "#fff",
        },
      }}
    >
      {label}
    </Button>
  );
};
